import {
  Users, Building2, MapPin 
} from 'lucide-react';

export const TABS = [
  {
    id: 'organization',
    label: 'Organization',
    href: '/settings/organization',
    icon: Building2 
  },
  {
    id: 'sites',
    label: 'Sites',
    href: '/settings/sites',
    icon: MapPin 
  },
  {
    id: 'users',
    label: 'Users',
    href: '/settings/users',
    icon: Users 
  },
];

export const ROLE_OPTIONS = [
  {
    value: 'viewer',
    label: 'Viewer' 
  },
  {
    value: 'operator',
    label: 'Operator' 
  },
  {
    value: 'manager',
    label: 'Manager' 
  },
  {
    value: 'admin',
    label: 'Admin' 
  },
];

export const SITE_TYPE_OPTIONS = [
  {
    value: 'ship',
    label: 'Ship' 
  },
  {
    value: 'hotel',
    label: 'Hotel' 
  },
  {
    value: 'restaurant',
    label: 'Restaurant' 
  },
  {
    value: 'warehouse',
    label: 'Warehouse' 
  },
];

export const TIMEZONE_OPTIONS = [
  {
    value: 'America/New_York',
    label: 'Eastern Time (ET)' 
  },
  {
    value: 'America/Chicago',
    label: 'Central Time (CT)' 
  },
  {
    value: 'America/Denver',
    label: 'Mountain Time (MT)' 
  },
  {
    value: 'America/Los_Angeles',
    label: 'Pacific Time (PT)' 
  },
  {
    value: 'Europe/London',
    label: 'London (GMT)' 
  },
  {
    value: 'Europe/Paris',
    label: 'Paris (CET)' 
  },
];

export const CURRENCY_OPTIONS = [
  {
    value: 'USD',
    label: 'USD - US Dollar' 
  },
  {
    value: 'EUR',
    label: 'EUR - Euro' 
  },
  {
    value: 'GBP',
    label: 'GBP - British Pound' 
  },
];
